import { render } from "./DistanceChart.vue?vue&type=template&id=48f254a7"
import script from "./DistanceChart.vue?vue&type=script&lang=js"
export * from "./DistanceChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__